module.exports = __webpack_public_path__ + "img/hungary.85015780.svg";